import validator from 'validator';

/**
 * Whether `value` type-checks against a company attribute's declared `type`.
 */
export function isAttributeType(type: string, value: any): boolean {
  switch (type) {
    case 'BOOLEAN':
      return (
        typeof value === 'boolean' || typeof value === 'number' || validator.isBoolean(String(value), { loose: true })
      );
    case 'NUMBER':
      return typeof value === 'number' || validator.isNumeric(String(value));
    case 'DATE':
      return validator.isDate(String(value), {
        strictMode: false, // Must be false. True is incompatible with delimiters array.
        format: 'YYYY-MM-DD',
        delimiters: ['-', '/'], // format can be 'YYYY-MM-DD' or 'YYYY/MM/DD'
      });
    case 'EMAIL':
      return validator.isEmail(String(value));
    case 'STRING':
    default:
      return typeof value === 'string';
  }
}

/**
 * Whether `value` counts as present for a required-field check.
 */
export function hasAttributeValue(value: any): boolean {
  if (value === undefined || value === null) {
    return false;
  }

  if (typeof value === 'string') {
    return value.trim() !== '';
  }

  return true;
}

/**
 * Coerces an import value to a boolean, case-insensitively for "yes"/"no" (the two values a raw
 * HRIS export actually uses), falling back to `validator`'s general boolean parsing for anything
 * else.
 */
export function toBoolean(value: string | null | undefined = '', isStrict = false): boolean {
  const v = String(value ?? '').toLowerCase();

  switch (v) {
    case 'no':
      return false;
    case 'yes':
      return true;
    default:
      return validator.toBoolean(String(value ?? ''), isStrict);
  }
}
